// Opening and closing the HTML content panels (.global-div)
const FADE_MS = 500; // matches the opacity transition in style.css

let lastFocused = null;

export function openPanel(panel) {
  if (!panel) return;

  lastFocused = document.activeElement;
  panel.style.display = "flex";
  document.documentElement.classList.add("no-scroll");
  setTimeout(() => {
    panel.style.opacity = "1";
  }, 10);

  // Move focus into the panel so keyboard and screen-reader users land there
  panel.querySelector(".close-button")?.focus({ preventScroll: true });
}

export function closePanel(panel) {
  if (!panel) return;

  panel.style.opacity = "0";
  document.documentElement.classList.remove("no-scroll");
  setTimeout(() => {
    panel.style.display = "none";
  }, FADE_MS);

  lastFocused?.focus?.({ preventScroll: true });
  lastFocused = null;

  window.dispatchEvent(new Event("panelclose"));
}

export function getOpenPanel() {
  return Array.prototype.find.call(
    document.getElementsByClassName("global-div"),
    (div) => div.style.display === "flex",
  );
}

const FOCUSABLE =
  'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

// Keep Tab / Shift+Tab cycling inside an open panel instead of reaching the page behind it
export function trapFocus(event, panel) {
  if (!panel) return;

  // Skip elements that aren't rendered (e.g. the hidden project tab)
  const focusable = [...panel.querySelectorAll(FOCUSABLE)].filter(
    (el) => el.getClientRects().length > 0,
  );
  if (!focusable.length) return;

  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  const inside = panel.contains(document.activeElement);

  if (event.shiftKey && (document.activeElement === first || !inside)) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && (document.activeElement === last || !inside)) {
    event.preventDefault();
    first.focus();
  }
}
